// Patient overview section questionnaire constants
export enum PatientOverviewQuestionnaireItem {
  // Demographics
  PATIENT_OVERVIEW_DEMOGRAPHICS_LEGAL_NAME = 'patient-overview/demographics/legal-name',
  PATIENT_OVERVIEW_DEMOGRAPHICS_PREFERRED_NAME = 'patient-overview/demographics/preferred-name',
  PATIENT_OVERVIEW_DEMOGRAPHICS_DATE_OF_BIRTH = 'patient-overview/demographics/date-of-birth',
  PATIENT_OVERVIEW_DEMOGRAPHICS_ADDRESS = 'patient-overview/demographics/address',
  PATIENT_OVERVIEW_DEMOGRAPHICS_GENDER = 'patient-overview/demographics/gender',
  PATIENT_OVERVIEW_DEMOGRAPHICS_SEX = 'patient-overview/demographics/sex',
  PATIENT_OVERVIEW_DEMOGRAPHICS_MEDICAID_ID = 'patient-overview/demographics/medicaid-id',

  // Care Team
  PATIENT_OVERVIEW_CARE_TEAM_CAREGIVER = 'patient-overview/care-team/caregiver',
  PATIENT_OVERVIEW_CARE_TEAM_CAREGIVER_NAME = 'patient-overview/care-team/caregiver/caregiver-name',
  PATIENT_OVERVIEW_CARE_TEAM_CAREGIVER_RELATION_TO_PATIENT = 'patient-overview/care-team/caregiver/relation-to-patient',
  PATIENT_OVERVIEW_CARE_TEAM_LEGAL_GUARDIAN = 'patient-overview/care-team/legal-guardian',
  PATIENT_OVERVIEW_CARE_TEAM_LEGAL_GUARDIAN_NAME = 'patient-overview/care-team/legal-guardian/name',
  PATIENT_OVERVIEW_CARE_TEAM_LEGAL_GUARDIAN_RELATION_TO_PATIENT = 'patient-overview/care-team/legal-guardian/relation-to-patient',
  PATIENT_OVERVIEW_CARE_TEAM_EMERGENCY_CONTACT = 'patient-overview/care-team/emergency-contact',
  PATIENT_OVERVIEW_CARE_TEAM_EMERGENCY_CONTACT_NAME = 'patient-overview/care-team/emergency-contact/name',
  PATIENT_OVERVIEW_CARE_TEAM_EMERGENCY_CONTACT_PHONE = 'patient-overview/care-team/emergency-contact/phone',
  PATIENT_OVERVIEW_CARE_TEAM_EMERGENCY_CONTACT_ADDRESS = 'patient-overview/care-team/emergency-contact/address',
  PATIENT_OVERVIEW_CARE_TEAM_ALTERNATE_CAREGIVER = 'patient-overview/care-team/alternate-caregiver',
  PATIENT_OVERVIEW_CARE_TEAM_ALTERNATE_CAREGIVER_NAME = 'patient-overview/care-team/alternate-caregiver/name',
  PATIENT_OVERVIEW_CARE_TEAM_ALTERNATE_CAREGIVER_PHONE = 'patient-overview/care-team/alternate-caregiver/phone',
  PATIENT_OVERVIEW_CARE_TEAM_ALTERNATE_CAREGIVER_ADDRESS = 'patient-overview/care-team/alternate-caregiver/address'
}
